import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { IBrand } from '../../../types';
import { Table, TableEmptyState } from '../shared';
import { brandsColumns, transformedBrands } from '../../../constants';
import { SvgVendors } from '../../../assets/svg/general';

interface IVendorTable {
  brands: IBrand[];
  loading: boolean;
  deleteMethod?: (id: string) => void;
}

export const VendorTable: FC<IVendorTable> = ({
  brands,
  loading,
  deleteMethod,
}) => {
  const navigate = useNavigate();

  const brandPage = (slug: string) => {
    navigate(`/dashboard/vendors/${slug}`);
  };

  const columns = useMemo(() => brandsColumns, []);

  if (brands.length === 0 && !loading) {
    return (
      <TableEmptyState
        icon={SvgVendors}
        title="No vendor onboarded"
        description="When you create vendors, it will show here"
        buttonText="Create vendor"
        onButtonClick={() => navigate('/dashboard/vendors/create')}
      />
    );
  }

  return (
    <Table
      data={transformedBrands(brands)}
      columns={columns}
      tableFor="brands"
      openPage={(slug: string) => brandPage(slug)}
      editMethod={(slug: string, e: any) => {
        e?.stopPropagation();
        navigate(`/dashboard/vendors/edit/${slug}`);
      }}
      showSearch={false}
      containerClassName="flex-1 flex flex-col min-h-0"
      deleteMethod={deleteMethod}
    />
  );
};
